import {
    VALIDATE_RECAPTCHA_LOADING, VALIDATE_RECAPTCHA_SUCCESS,
    VALIDATE_RECAPTCHA_ERROR, VALIDATE_RECAPTCHA_RESET
} from "../actions/actionRecaptcha";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "validRecaptcha";

const initialState = {
    validToken: loadState(sessionKey, false),
    loading: false,
    validTokenError: ''
};

function reducerRecaptcha(state = initialState, action) {
    switch (action.type) {
        case VALIDATE_RECAPTCHA_LOADING: {
            return {
                ...state,
                loading: true,
                validToken: false,
                validTokenError: ''
            };
        }
        case VALIDATE_RECAPTCHA_SUCCESS: {

            saveState(sessionKey, true);

            return {
                ...state,
                loading: false,
                validToken: true,
                validTokenError: ''
            };
        }
        case VALIDATE_RECAPTCHA_ERROR: {


            saveState(sessionKey, false);

            let error = "";
            if (action.error.Errors) {
                error = action.error.Errors[0].ErrorMessage
            }
            else
                error = action.error.message;

            return {
                ...state,
                loading: false,
                validToken: false,
                validTokenError: error
            }
        }
        case VALIDATE_RECAPTCHA_RESET: {

            saveState(sessionKey, false);

            return {
                ...state,
                loading: false,
                validToken: false,
                validTokenError: ''
            }

        }
        default: {
            return state;
        }
    }
}

export default reducerRecaptcha;